import { Fragment } from 'react';
import { Box, Button, CardActions, CardContent, Modal } from '@mui/material';
import ArrowBackIosNewTwoToneIcon from '@mui/icons-material/ArrowBackIosNewTwoTone';
import { ConfirmCard } from '../Layout/styles';
import { Quotation, TravelDay } from '../../@types/contractors';
import EditIcon from '@mui/icons-material/Edit';

interface TravelDetailsModalProps {
    open: boolean;
    onClose: () => void;
    quotation: Quotation | null;
}

export default function TravelDetailsModal({ open, onClose, quotation }: TravelDetailsModalProps) {
    if (!quotation) {
        return null;
    }

    const parsedOfferDescription = getParsedOfferDescription(quotation)
    const day = parsedOfferDescription?.days[0] as TravelDay

    const contractorBuses = quotation.QuotationRequestContractor?.QuotationRequestContractorBuses;
    return (
        <Modal open={open} onClose={onClose}>
            <ConfirmCard>
                {parsedOfferDescription ? (
                    <CardContent sx={{ p: 2 }}>
                        <p>Utazóközönség: {parsedOfferDescription?.travelType}</p>
                        <p>Létszám: {parsedOfferDescription?.numberOfPassengers} fő</p>
                        <p>Szolgáltatási igény: {parsedOfferDescription?.serviceLevel}</p>
                        <h2>Az utazás részletei:</h2>
                        <p>
                            Indulás: {day?.departure} | {day?.source} | Érkezés: {day?.destination}
                        </p>
                        <p>
                            Visszaindulás: {day?.comeBackDeparture} | Érkezés: {day?.comeBackDestination}
                        </p>
                        <p>Az útvonal a következő:</p>
                        <p>
                            Menetrend: {day?.source} - {day?.destination}
                        </p>
                        <p>{day?.details}</p>
                        {quotation.QuotationRequestContractor?.Accepted && quotation.QuotationRequestContractor.AcceptedQuotationId === quotation.ID && (
                            <>
                                <h2>Beküldött vezénylés:</h2>
                                {contractorBuses?.length > 0 ? (
                                    <>
                                        <p>Buszok:</p>
                                        {contractorBuses.map((bus, i) => (
                                            <Fragment key={i}>
                                                <p>
                                                    {bus.licensePlate}:{' '}
                                                    {bus.busDrivers?.map((busDriver, idx) => (
                                                        <span>
                                                            {idx > 0 && ', '} {busDriver.name} ({busDriver.phoneNumber})
                                                        </span>
                                                    ))}
                                                </p>
                                            </Fragment>
                                        ))}
                                    </>
                                ) : (
                                    <p>még nincs megadva</p>
                                )}
                            </>
                        )}
                    </CardContent>
                ) : (
                    <CardContent sx={{ p: 2 }}>
                        <h2>Nincs megjelenítendő adat</h2>
                    </CardContent>
                )}
                <CardActions>
                    <CardActionButtons quotation={quotation} onClose={onClose} />
                </CardActions>
            </ConfirmCard>
        </Modal>
    );
}

const CardActionButtons = ({ quotation, onClose }: { quotation: Quotation; onClose: () => void }) => {
    const isAccepted = quotation.QuotationRequestContractor?.Accepted && quotation.QuotationRequestContractor.AcceptedQuotationId === quotation.ID;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <Box>
                {isAccepted && (
                    <Button
                        component='a'
                        href={`/trip_assignment_details?qrc=${quotation.QuotationRequestContractor.ID}`}
                        target='_self'
                        sx={{ mx: 1, borderRadius: 50 }}
                        variant={'contained'}
                        size={'small'}
                        color={'info'}
                        startIcon={<EditIcon />}>
                        Vezénylés módosítása
                    </Button>
                )}
            </Box>
            <Button
                sx={{ mx: 1, borderRadius: 50 }}
                variant={'contained'}
                size={'small'}
                color={'info'}
                onClick={() => onClose()}
                startIcon={<ArrowBackIosNewTwoToneIcon />}>
                Bezár
            </Button>
        </Box>
    );
};

export const getParsedOfferDescription = (quotation: Quotation) => {
    let offerDescription = quotation.QuotationRequestContractor?.QuotationRequest?.OfferDescription;
    if (offerDescription === '') {
        offerDescription = quotation.QuotationRequestDetails?.OfferDescription;
    }
    try {
       return JSON.parse(offerDescription);
    } catch (error) {
        console.error(error);
    }
    return null;
}